import { GridColumn } from 'src/components/GridWrapper';
import AmountFooterCell from 'src/sections/accrual-report/accrual_grid_cell/AmountFooterCell';
import ChildExpandedCell from 'src/sections/accrual-report/accrual_grid_cell/ChildExpandedCell';
import ChildHeaderCell from 'src/sections/accrual-report/accrual_grid_cell/ChildHeaderCell';
import CountFooterCell from 'src/sections/accrual-report/accrual_grid_cell/CountFooterCell';
import ExpandedCell from 'src/sections/accrual-report/accrual_grid_cell/ExpandedCell';
import AccrualHeaderCell from 'src/sections/accrual-report/accrual_grid_cell/HeaderCell';
import AccrualLinkCell from 'src/sections/accrual-report/accrual_grid_cell/Link';

const expandedColumn = {
  field: 'expanded',
  title: '',
  width: '30px',
  component: ExpandedCell,
  headerCell: AccrualHeaderCell,
  menu: false,
  sortable: false,
};

const childAccrualExpandedColumn = (glCd: string) => ({
  field: 'expanded',
  title: glCd,
  width: '30px',
  component: ChildExpandedCell,
  headerCell: ChildHeaderCell,
  menu: false,
  sortable: false,
});

const commonAccrualReportColumns = (
  hasFooter: boolean,
  hasLinkComponent: boolean
): GridColumn<any>[] => [
  {
    field: 'link',
    title: 'Link',
    menu: false,
    sortable: false,
    component: hasLinkComponent ? AccrualLinkCell : undefined,
  },
  {
    field: 'supplierName',
    title: 'Supplier',
    filter: 'text',
    menu: true,
    sortable: true,
  },
  {
    field: 'grniItemCount',
    title: 'GRNI Item Count',
    filter: 'numeric',
    menu: true,
    sortable: true,
    footerCell: hasFooter ? CountFooterCell : undefined,
  },
  {
    field: 'grniDocCount',
    title: 'GRNI Doc Count',
    filter: 'numeric',
    menu: true,
    sortable: true,
    footerCell: hasFooter ? CountFooterCell : undefined,
  },
  {
    field: 'poTotal',
    title: ' PO Total',
    filter: 'numeric',
    menu: true,
    format: '{0:c2}',
    sortable: true,
    footerCell: hasFooter ? AmountFooterCell : undefined,
  },
  {
    field: 'amountInPeriod',
    title: ' PO Amount in Period',
    filter: 'numeric',
    menu: true,
    format: '{0:c2}',
    sortable: true,
    footerCell: hasFooter ? AmountFooterCell : undefined,
  },
  {
    field: 'accrualAmount',
    title: 'Accrual Amount',
    filter: 'numeric',
    menu: true,
    format: '{0:c2}',
    sortable: true,
    footerCell: hasFooter ? AmountFooterCell : undefined,
  },
];

export const viewAccrualColumns: GridColumn<any>[] = [
  expandedColumn,
  {
    field: 'glCd',
    title: 'GL Code',
    filter: 'text',
    menu: true,
    sortable: true,
    footerCell: () => <td>Totals:</td>,
  },

  ...commonAccrualReportColumns(true, false),
];

export const useAccrualChildColumns: (glCd: string) => GridColumn<any>[] = (glCd: string) => [
  childAccrualExpandedColumn(glCd),
  {
    field: 'poNumber',
    title: 'PO',
    filter: 'text',
    menu: true,
    sortable: true,
  },
  ...commonAccrualReportColumns(false, true),
];

export const subChildAccrualReportColumns: GridColumn<any>[] = [
  {
    field: 'lineItemNumber',
    title: 'Line Item',
    filter: 'text',
    menu: true,
    sortable: true,
  },

  ...commonAccrualReportColumns(false, true),
];
